// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__FbFbH","left":"StickyBox_left__3Yaq3","right":"StickyBox_right__1yM7m"};